<template>
    <div class="bottom-logos">
        <img src="../../../assets/images/postalNewCustomer/logos.png" alt="">
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {}
    },
    computed: {},
    created() { },
    mounted() { },
    beforeDestroy() { },
    methods: {},
}
</script>

<style lang="scss" scoped>
.bottom-logos {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 4.267vw;
    img {
        width: 74.133vw;
    }
}
</style>